// import React, { useState } from 'react';
// import PageHeader from '../components/PageHeader';

// export default function Contact() {
//   const [form, setForm] = useState({ name: '', email: '', message: '' });
//   const [sent, setSent] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Contact form has no backend endpoint yet — wire this up to a future
//     // /api/public/contact endpoint, or forward to WhatsApp/email in the meantime.
//     setSent(true);
//   };

//   return (
//     <div>
//       <PageHeader
//         eyebrow="Contact Us"
//         title="Get In Touch"
//         subtitle="Reach us via WhatsApp, phone, email, or by visiting our office."
//       />
//       <section className="section">
//         <div className="container grid grid-2">
//           <div>
//             <h2>Office Details</h2>
//             <p><strong>WhatsApp / Call:</strong> 071 450 5692 / 079 317 5647 / 072 104 7556</p>
//             <p><strong>Email:</strong> smartpoint.edustation@gmail.com</p>
//             <p><strong>Office Hours:</strong> Monday – Friday, 08:00 – 16:30</p>
//             <p><strong>Address:</strong> 1363/16 Lindela Wessile Street, Vukuzakhe, Volksrust</p>
//             <div style={{ marginTop: 20, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
//               <a href="https://wa.me/27714505692" className="btn btn-gold" target="_blank" rel="noopener noreferrer">
//                 Message Us on WhatsApp
//               </a>
//               <a
//                 href="https://maps.app.goo.gl/omAyoVY5vZXdQyoM8"
//                 className="btn btn-outline-dark"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 View on Google Maps
//               </a>
//             </div>
//           </div>

//           <div className="card">
//             {sent ? (
//               <div className="success-box">Thank you — your message has been received. We'll be in touch soon.</div>
//             ) : (
//               <form onSubmit={handleSubmit}>
//                 <div className="form-group">
//                   <label>Full Name</label>
//                   <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
//                 </div>
//                 <div className="form-group">
//                   <label>Email</label>
//                   <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
//                 </div>
//                 <div className="form-group">
//                   <label>Message</label>
//                   <textarea rows="5" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
//                 </div>
//                 <button type="submit" className="btn btn-gold btn-block">Send Message</button>
//               </form>
//             )}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { submitContactMessage } from '../services/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await submitContactMessage(form);
      setSent(true);
    } catch (err) {
      setError('Something went wrong sending your message. Please try again, or reach us on WhatsApp instead.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Contact Us"
        title="Get In Touch"
        subtitle="Reach us via WhatsApp, phone, email, or by visiting our office."
      />
      <section className="section">
        <div className="container grid grid-2">
          <div>
            <h2>Office Details</h2>
            <p><strong>WhatsApp / Call:</strong> 071 450 5692 / 079 317 5647 / 072 104 7556</p>
            <p><strong>Email:</strong> tmagneficent@gmail.com</p>
            <p><strong>Office Hours:</strong> Monday – Friday, 08:00 – 16:30</p>
            <p><strong>Address:</strong> 1363/16 Lindela Wessile Street, Vukuzakhe, Volksrust</p>
            <div style={{ marginTop: 20, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a href="https://wa.me/27714505692" className="btn btn-gold" target="_blank" rel="noopener noreferrer">
                Message Us on WhatsApp
              </a>
              <a
                href="https://maps.app.goo.gl/omAyoVY5vZXdQyoM8"
                className="btn btn-outline-dark"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </div>
          </div>

          <div className="card">
            {sent ? (
              <div className="success-box">Thank you — your message has been received. We'll be in touch soon.</div>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && <p className="error-text" style={{ marginBottom: 16 }}>{error}</p>}
                <div className="form-group">
                  <label>Full Name</label>
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea rows="5" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                </div>
                <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
